// extracted by mini-css-extract-plugin
module.exports = {"modalTitle":"AddNoteDialog_modalTitle_HG6k1","noteInput":"AddNoteDialog_noteInput_3ZhOo","spinAround":"AddNoteDialog_spinAround_1kNZ9"};